import styled from 'styled-components'

export const Wrapper = styled.div`
  max-width: ${props => props.theme.limits.componentMaxWidth};
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  font-family: ${props => props.theme.typography.lato};
  //
  //body {
  //  background-color: white !important;
  //}
  .__react_component_tooltip {
    background-color: ${props => props.theme.colors.woodyBrown};
    &.type-dark.place-top::after {
      border-top-color: ${props => props.theme.colors.woodyBrown};
      border-top-width: 8px;
    }
    &.type-dark.place-bottom::after {
      border-bottom-color: ${props => props.theme.colors.woodyBrown};
      border-bottom-width: 8px;
    }
    &.type-dark.place-left::after {
      border-left-color: ${props => props.theme.colors.woodyBrown};
      border-left-width: 5px;
      right: -5px;
    }
    &.type-dark.place-right::after {
      border-right-color: ${props => props.theme.colors.woodyBrown};
      border-right-width: 5px;
      left: -5px;
    }
    &.show {
      opacity: 1 !important;
    }
  }
`
